import { ENDPOINTS } from './constants';

export const BASE_URL = process.env.REACT_APP_BASE_URL || '/';
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || '/api/';
export const CAPTCHA_KEY = '6Ld_f9cUAAAAAL9SVcMxYsikc-mONMFZfiUWcvX2';
export const AUTH_TOKEN_KEY = 'auth-token';

export const TOKEN_ENDPOINTS = [ENDPOINTS.LOGIN];
